import { useCallback, useEffect, useState } from "react";
import { fetchBudgetAttachmentsV2, uploadBudgetFilesV2 } from "../../../api/fetchBudgetV2";
import { IBudgetAttachment } from "../../../models/budgetV2";
import { IBudgetAttachmentFile } from "../components/budgetAttachments/types";

export const useBudgetAttachments = (budgetId?: string) => {
  const [attachments, setAttachments] = useState<IBudgetAttachmentFile[]>([]);
  const [loadingAttachments, setLoadingAttachments] = useState(false);

  useEffect(() => {
    if (!budgetId) {
      setAttachments([]);
      return;
    }

    const loadAttachments = async () => {
      setLoadingAttachments(true);
      try {
        const budgetAttachments = await fetchBudgetAttachmentsV2(budgetId);
        setAttachments(
          budgetAttachments.map((attachment: IBudgetAttachment) => ({
            name: attachment.name,
            type: attachment.contentType,
            size: attachment.contentSize,
            link: attachment.link,
            updatedAt: attachment.updatedAt,
          }))
        );
      } catch (error) {
        console.error("[useBudgetAttachments] Erro ao carregar anexos:", error);
        setAttachments([]);
      } finally {
        setLoadingAttachments(false);
      }
    };

    loadAttachments();
  }, [budgetId]);

  const addAttachments = useCallback((newFiles: IBudgetAttachmentFile[]) => {
    setAttachments((prev) => [...prev, ...newFiles]);
  }, []);

  const removeAttachment = useCallback((index: number) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const uploadPendingAttachments = useCallback(async (): Promise<boolean> => {
    if (!budgetId) return true;
    const filesToUpload = attachments
      .filter((item) => item.file !== undefined)
      .map((item) => item.file as File);
    if (filesToUpload.length === 0) return true;
    return uploadBudgetFilesV2(budgetId, filesToUpload);
  }, [attachments, budgetId]);

  return {
    attachments,
    loadingAttachments,
    addAttachments,
    removeAttachment,
    uploadPendingAttachments,
  };
};
